export interface UserDTO {
    id: number;
    email: string;
    role: string;
    accessToken: string;
    refreshToken: string
    calendarId: number;
}

export interface UserWriteDTO {
    email: string;
    role: string;
    accessToken: string;
    calendarId: number;
}

export interface LoginWriteDTO {
    email: string;
    password: string;
    deviceId: string;
}

export interface UserPatchDTO {
        email: string;
        role: string
        lastLogin: Date;
        calendarId: number;
        terms: boolean;
        cookies: boolean;

}

export function createLogin(email: string, password: string, deviceId: string) {
    return { email: email, password: password, deviceId: deviceId };
}

export function createUser(email: string,
    role: string,
    accessToken: string,
    calendarId: number
) {
    return { email: email, role: role, accessToken: accessToken, calendarId: calendarId };
}